import { SerializationExceptioneqrdve3ts2n9 as SerializationException } from '../SerializationExceptions.mjs';
import { getKClassFromExpression348iqjl4fnx2f as getKClassFromExpression } from '../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/reflection.mjs';
import {
  toString1pkumu07cwy4m as toString,
  protoOf180f3jzyo7rfj as protoOf,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { Char19o2r8palgjof as Char } from '../../../../kotlin-kotlin-stdlib/kotlin/Char.mjs';
import {
  decodeSerializableElement$default1kkisaow5bg5n as decodeSerializableElement$default,
  decodeSerializableValue3h7ajfesxzjda as decodeSerializableValue,
  decodeSequentially27kmi8jnnsnbc as decodeSequentially,
  decodeCollectionSize3l4gjp9ef5h8u as decodeCollectionSize,
  Decoder23nde051s631g as Decoder,
  CompositeDecoder2tzm7wpwkr0og as CompositeDecoder,
} from './Decoding.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var AbstractDecoderClass;
function AbstractDecoder() {
  if (AbstractDecoderClass === VOID) {
    class $ {
      t1q() {
        throw SerializationException().n1o(toString(getKClassFromExpression(this)) + " can't retrieve untyped values");
      }
      u1q() {
        return true;
      }
      v1q() {
        return null;
      }
      w1q() {
        var tmp = this.t1q();
        return typeof tmp === 'boolean' ? tmp : THROW_CCE();
      }
      x1q() {
        var tmp = this.t1q();
        return typeof tmp === 'number' ? tmp : THROW_CCE();
      }
      y1q() {
        var tmp = this.t1q();
        return typeof tmp === 'number' ? tmp : THROW_CCE();
      }
      z1q() {
        var tmp = this.t1q();
        return typeof tmp === 'number' ? tmp : THROW_CCE();
      }
      a1r() {
        var tmp = this.t1q();
        return typeof tmp === 'bigint' ? tmp : THROW_CCE();
      }
      b1r() {
        var tmp = this.t1q();
        return typeof tmp === 'number' ? tmp : THROW_CCE();
      }
      c1r() {
        var tmp = this.t1q();
        return typeof tmp === 'number' ? tmp : THROW_CCE();
      }
      d1r() {
        var tmp = this.t1q();
        return tmp instanceof Char() ? tmp.e4_1 : THROW_CCE();
      }
      e1r() {
        var tmp = this.t1q();
        return typeof tmp === 'string' ? tmp : THROW_CCE();
      }
      f1r(enumDescriptor) {
        var tmp = this.t1q();
        return typeof tmp === 'number' ? tmp : THROW_CCE();
      }
      g1r(descriptor) {
        return this;
      }
      h1r(deserializer, previousValue) {
        return this.i1r(deserializer);
      }
      j1r(descriptor) {
        return this;
      }
      k1r(descriptor) {
      }
      l1r(descriptor, index) {
        return this.w1q();
      }
      m1r(descriptor, index) {
        return this.x1q();
      }
      n1r(descriptor, index) {
        return this.y1q();
      }
      o1r(descriptor, index) {
        return this.z1q();
      }
      p1r(descriptor, index) {
        return this.a1r();
      }
      q1r(descriptor, index) {
        return this.b1r();
      }
      r1r(descriptor, index) {
        return this.c1r();
      }
      s1r(descriptor, index) {
        return this.d1r();
      }
      t1r(descriptor, index) {
        return this.e1r();
      }
      u1r(descriptor, index) {
        return this.g1r(descriptor.v1p(index));
      }
      v1r(descriptor, index, deserializer, previousValue) {
        return this.h1r(deserializer, previousValue);
      }
      x1r(descriptor, index, deserializer, previousValue) {
        // Inline function 'kotlinx.serialization.encoding.decodeIfNullable' call
        var isNullabilitySupported = deserializer.s1m().h1p();
        var tmp;
        if (isNullabilitySupported || this.u1q()) {
          tmp = this.h1r(deserializer, previousValue);
        } else {
          tmp = this.v1q();
        }
        return tmp;
      }
    }
    protoOf($).w1r = decodeSerializableElement$default;
    protoOf($).i1r = decodeSerializableValue;
    protoOf($).z1r = decodeSequentially;
    protoOf($).b1s = decodeCollectionSize;
    initMetadataForClass($, 'AbstractDecoder', VOID, VOID, [Decoder(), CompositeDecoder()]);
    AbstractDecoderClass = $;
  }
  return AbstractDecoderClass;
}
//region block: exports
export {
  AbstractDecoder as AbstractDecoder35guh02ubh2hm,
};
//endregion

//# sourceMappingURL=AbstractDecoder.mjs.map
